import { render } from "./ChildReport.vue?vue&type=template&id=d8152a7e&ts=true"
import script from "./ChildReport.vue?vue&type=script&lang=ts"
export * from "./ChildReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__